module.exports = __webpack_public_path__ + "img/img-business-platform-sec-10.png";